/* @flow */

export const KEY_CODES = {
    ENTER: 13,
    SPACE: 32
};

export const ATTRIBUTES = {
    UID: 'data-uid'
};
